<template>
  <div>
    <EquipmentEditHeader
      v-if="isAdmin"
      data-cy="tubing-search-view-edit-header"
    />
    <EquipmentTable
      data-cy="tubing-search-view-edit-header"
      @select="$emit('select', $event.data as Tubings)"
    />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import type { Tubings_Type_Enum, Tubings } from "gql/api";
import { useTubings } from "@/composables/equipment/tubings/tubings";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";

const props = defineProps<{
  isAdmin: boolean;
  allowedTubingTypes?: Tubings_Type_Enum[];
}>();

defineEmits<{
  (event: "select", data: Tubings): void;
}>();

const tubingSearch = useTubings(props.isAdmin, props.allowedTubingTypes);

provide("equipment", tubingSearch);
</script>
